/**
 * ConnectButton - Wallet connect button tile
 */
import React from 'react';

const ConnectButton = ({ onClick }) => (
  <button
    onClick={onClick}
    style={{
      position: 'relative',
      width: '39px',
      height: '39px',
      borderRadius: '3px',
      background: 'linear-gradient(135deg, #1E7B34 0%, #145A25 50%, #0D3D18 100%)',
      border: '1px solid rgba(30, 123, 52, 0.6)',
      boxShadow: '2px 3px 0 rgba(0, 0, 0, 0.5), 0 0 15px rgba(30, 123, 52, 0.25)',
      cursor: 'pointer',
      padding: 0,
      margin: 0,
      outline: 'none',
      overflow: 'hidden',
      transition: 'all 0.15s ease',
      pointerEvents: 'auto',
      zIndex: 1,
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = 'linear-gradient(135deg, #2E8B3E 0%, #1E7B34 50%, #145A25 100%)';
      e.currentTarget.style.boxShadow = '2px 3px 0 rgba(0, 0, 0, 0.5), 0 0 25px rgba(30, 123, 52, 0.4)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = 'linear-gradient(135deg, #1E7B34 0%, #145A25 50%, #0D3D18 100%)';
      e.currentTarget.style.boxShadow = '2px 3px 0 rgba(0, 0, 0, 0.5), 0 0 15px rgba(30, 123, 52, 0.25)';
    }}
  >
    {/* Top highlight */}
    <div style={{ position: 'absolute', top: '1px', left: '1px', right: '1px', height: '14px', borderRadius: '2px 2px 0 0', background: 'linear-gradient(to bottom, rgba(129, 199, 132, 0.5) 0%, rgba(102, 187, 106, 0.2) 40%, transparent 100%)', pointerEvents: 'none' }} />
    {/* Left highlight */}
    <div style={{ position: 'absolute', top: '1px', left: '1px', width: '12px', bottom: '1px', borderRadius: '2px 0 0 2px', background: 'linear-gradient(to right, rgba(129, 199, 132, 0.4) 0%, rgba(102, 187, 106, 0.15) 40%, transparent 100%)', pointerEvents: 'none' }} />
    {/* Atomic number */}
    <span style={{ position: 'absolute', top: '2px', right: '3px', fontSize: '7px', fontWeight: 600, color: 'rgba(255, 255, 255, 0.7)', fontFamily: 'system-ui, -apple-system, sans-serif', lineHeight: 1 }}>
      6
    </span>
    {/* Element symbol */}
    <span style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', marginTop: '-3px', fontSize: '18px', fontWeight: 700, color: 'white', fontFamily: 'system-ui, -apple-system, sans-serif', lineHeight: 1 }}>
      C
    </span>
    {/* Element name */}
    <span style={{ position: 'absolute', bottom: '3px', left: '50%', transform: 'translateX(-50%)', fontSize: '5px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.7)', fontFamily: 'system-ui, -apple-system, sans-serif', textTransform: 'uppercase', letterSpacing: '0.3px', lineHeight: 1, whiteSpace: 'nowrap' }}>
      Connect
    </span>
  </button>
);

export default ConnectButton;
